/* @flow */
// The replacement: /\v(.*): null,/export const \1 = prefix\('\1'\);/g
const prefix = str => `station/reports/${str}`;

export const CLEAR_LIST = prefix('CLEAR_LIST');

export const FETCH_LIST = prefix('FETCH_LIST');
export const FETCH_LIST_SUCCESS = prefix('FETCH_LIST_SUCCESS');
export const FETCH_LIST_FAILURE = prefix('FETCH_LIST_FAILURE');

export const FETCH_METADATA = prefix('FETCH_METADATA');
export const FETCH_METADATA_SUCCESS = prefix('FETCH_METADATA_SUCCESS');
export const FETCH_METADATA_FAILURE = prefix('FETCH_METADATA_FAILURE');
export const FETCH_DATA_ALREADY_CACHED = prefix('FETCH_DATA_ALREADY_CACHED');
export const CLEAR_REPORT_METADATA_CACHE = prefix('CLEAR_REPORT_METADATA_CACHE');

export const STORE = prefix('STORE');
export const STORE_FROM_LOCAL = prefix('STORE_FROM_LOCAL'); // Used to store report objects already in other parts of state
export const STORE_SUCCESS = prefix('STORE_SUCCESS');
export const STORE_FAILURE = prefix('STORE_FAILURE');

export const SET_CURRENT_ID = prefix('SET_CURRENT_ID');

export const SET_DISPLAY_OPTIONS = prefix('SET_DISPLAY_OPTIONS');
export const REFETCH_REPORTS = prefix('REFETCH_REPORTS');

export const REMOVE = prefix('REMOVE');
export const REMOVE_SUCCESS = prefix('REMOVE_SUCCESS');
export const REMOVE_FAILURE = prefix('REMOVE_FAILURE');

export const REINDEX = prefix('REINDEX');
export const REINDEX_SUCCESS = prefix('REINDEX_SUCCESS');
export const REINDEX_FAILURE = prefix('REINDEX_FAILURE');

export const MODIFY_DISTRIBUTION = prefix('MODIFY_DISTRIBUTION');
export const MODIFY_DISTRIBUTION_SUCCESS = prefix('MODIFY_DISTRIBUTION_SUCCESS');
export const MODIFY_DISTRIBUTION_FAILURE = prefix('MODIFY_DISTRIBUTION_FAILURE');

export const SET_ATTRIBUTE = prefix('SET_ATTRIBUTE');
export const SET_ATTRIBUTE_SUCCESS = prefix('SET_ATTRIBUTE_SUCCESS');
export const SET_ATTRIBUTE_FAILURE = prefix('SET_ATTRIBUTE_FAILURE');

export const REMOVE_ATTRIBUTE = prefix('REMOVE_ATTRIBUTE');
export const REMOVE_ATTRIBUTE_SUCCESS = prefix('REMOVE_ATTRIBUTE_SUCCESS');
export const REMOVE_ATTRIBUTE_FAILURE = prefix('REMOVE_ATTRIBUTE_FAILURE');

export const SET_ENCLAVE_TAG = prefix('SET_ENCLAVE_TAG');
export const SET_ENCLAVE_TAGS_BULK = prefix('SET_ENCLAVE_TAGS_BULK');
export const SET_ENCLAVE_TAGS_BULK_SUCCESS = prefix('SET_ENCLAVE_TAGS_BULK_SUCCESS');
export const SET_ENCLAVE_TAGS_BULK_FAILURE = prefix('SET_ENCLAVE_TAGS_BULK_FAILURE');

export const SET_ENCLAVE_TAG_SUCCESS = prefix('SET_ENCLAVE_TAG_SUCCESS');
export const SET_ENCLAVE_TAG_FAILURE = prefix('SET_ENCLAVE_TAG_FAILURE');

export const REMOVE_ENCLAVE_TAG = prefix('REMOVE_ENCLAVE_TAG');
export const REMOVE_ENCLAVE_TAG_SUCCESS = prefix('REMOVE_ENCLAVE_TAG_SUCCESS');
export const REMOVE_ENCLAVE_TAG_FAILURE = prefix('REMOVE_ENCLAVE_TAG_FAILURE');

export const EXPORT_REPORT = prefix('EXPORT_REPORT');
export const COPY_REPORT = prefix('COPY_REPORT');
export const COPY_REPORT_SUCCESS = prefix('COPY_REPORT_SUCCESS');
export const COPY_REPORT_FAILURE = prefix('COPY_REPORT_FAILURE');

export const MOVE_REPORT = prefix('MOVE_REPORT');
export const MOVE_REPORT_SUCCESS = prefix('MOVE_REPORT_SUCCESS');
export const MOVE_REPORT_FAILURE = prefix('MOVE_REPORT_FAILURE');


// WEBPACK FOOTER //
// ./src/app/modules/reports/action-types.js